import { render, staticRenderFns } from "./myvideos.vue?vue&type=template&id=50fb1c20&scoped=true&"
import script from "./myvideos.vue?vue&type=script&lang=js&"
export * from "./myvideos.vue?vue&type=script&lang=js&"
import style0 from "./myvideos.vue?vue&type=style&index=0&id=50fb1c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb1c20",
  null
  
)

export default component.exports